import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ITrainingProgram } from 'app/models/training/training-program';
import { ITrainingProgramContact } from 'app/models/training/training-program-contact';
import { SharedService } from 'app/services/core/shared.service';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import { waitForQrCodeRender } from 'app/shared/utils/print';
import { environment } from '@env/environment';

@Component({
    selector: 'app-print-training-program',
    templateUrl: './print-training-program.component.html',
    styleUrls: ['./print-training-program.component.scss'],
    standalone: false
})
export class PrintTrainingProgramComponent implements OnInit {
  public url = environment.baseUrl;
  public responsibleParty: ITrainingProgramContact = {
    id: 0,
    firstName: '',
    lastName: '',
    title: '',
    email: '',
    phone: '',
    attestation: false,
    isResponsible: false,
    isDirector: false,
    isLeadEducator: false,
    isBusinessAgent: false,
    isInstructor: false,
    trainingProgramId: 0,
    dateCreated: '',
    archived: false
  };

  constructor(public sharedService: SharedService,
    public dialogRef: MatDialogRef<PrintTrainingProgramComponent>,
    @Inject(MAT_DIALOG_DATA) public program: ITrainingProgram) { }

  ngOnInit(): void {
    this.responsibleParty = this.program.trainingProgramContacts.find(tpc => tpc.isResponsible);
  }

  async print(): Promise<void> {
    const content = document.getElementById('certificate');
    await waitForQrCodeRender(content);
    const drawOptions = {
      scale: 0.75,
      paperSize: 'letter',
      margin: { top: '1cm', left: '1cm', right: '1cm', bottom: '2.5cm' },
      template: (data) => `
        <div style="position: absolute; bottom: 0; left: 0; right: 0; text-align: center; font-size: 12px; border-top: 1px solid black; padding-top: 4px;">
            Medical Cannabis & Psilocybin section | PO Box 14450, Portland OR 97293-0450 <br>OHA.Psilocybin@oha.oregon.gov | www.Oregon.gov/psilocybin
        </div>
      `
    };

    drawDOM(content, drawOptions)
      .then(group => exportPDF(group, drawOptions))
      .then(pdfDataUri => {
        const pdfBlob = this.dataUriToBlob(pdfDataUri);
        const blobUrl = URL.createObjectURL(pdfBlob);

        const iframe = document.createElement('iframe');

        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow?.focus();
            iframe.contentWindow?.print();
          }, 100);
        };

        document.body.appendChild(iframe);
        iframe.src = blobUrl;
      });
  }

  private dataUriToBlob(dataUri: string): Blob {
    const byteString = atob(dataUri.split(',')[1]);
    const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  cancel(): void {
    this.dialogRef.close('cancel');
  }

}
